module.exports = __webpack_public_path__ + "static/media/replace-participant.c5a43fa1.svg";